import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

/**
 * The /apply pages are applicant-only, and the API answers 403 once the role
 * has changed (e.g. hired -> driver) while the browser still holds the old
 * profile. On a 403, refresh the profile and send the user to their own home.
 * Returns true when it redirected.
 */
const useLeaveIfNotApplicant = () => {
  const navigate = useNavigate();
  const { refreshUserProfile } = useAuth();

  return useCallback(async (error) => {
    if (error?.status !== 403) return false;
    const result = await refreshUserProfile();
    const role = result?.user?.role;
    if (!role || role === 'applicant') return false;
    navigate(role === 'driver' ? '/driver-portal' : '/dashboard', { replace: true });
    return true;
  }, [navigate, refreshUserProfile]);
};

export default useLeaveIfNotApplicant;
